// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UVOKkr48G0kshu9dGoXI{text-align:center;max-width:688px;margin:0 auto;height:100%;border-radius:16px}`, "",{"version":3,"sources":["webpack://./../../components/react/src/components/WaitlistCard/waitlistCard.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CACA,eAAA,CACA,aAAA,CACA,WAAA,CACA,kBAAA","sourcesContent":[".root {\n  text-align: center;\n  max-width: 688px;\n  margin: 0 auto;\n  height: 100%;\n  border-radius: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `UVOKkr48G0kshu9dGoXI`
};
export default ___CSS_LOADER_EXPORT___;
